import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    margin-right: 4%;

  .ball-number {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    color: white;
    font-size: 22px;
  }
`;

export const BallNumber = ({questionNumber}) => {
  return (
    <Wrapper>
      <div className="ball-number">{questionNumber}</div>
    </Wrapper>
  );
};
